<!-- Référentiel "Communauté" -->
<referentiel-communaute #referentiel [sbtConfigUsed]="sbtConfigUsed"></referentiel-communaute>
<!-- Référentiel "Catégorie voyageur" -->
<referentiel-categorie-voyageur #referentiel [sbtConfigUsed]="sbtConfigUsed"></referentiel-categorie-voyageur>
<!-- Référentiel "RLS" -->
<referentiel-rls #referentiel [sbtConfigUsed]="sbtConfigUsed"></referentiel-rls>